import { create } from "zustand";

/** What to open. Any screen can ask for a meeting without routing: a calendar Join button, a notification deep link
 *  (`/meetings/<id>`), a pasted join link. */
export type MeetingTarget = { meetingId: string } | { code: string } | { joinUrl: string };

export interface MeetingUiState {
  /** the meeting the full-screen launcher is showing, or null when it is closed */
  target: MeetingTarget | null;
  /** the camera and microphone chosen on the pre-join screen (empty = the browser default) */
  devices: { micId: string; camId: string };
}

export const meetingUi = create<MeetingUiState>(() => ({ target: null, devices: { micId: "", camId: "" } }));

/** Open a meeting in the full-screen launcher (<MeetingLauncher/> must be mounted once at the app root). */
export const openMeeting = (target: MeetingTarget): void => meetingUi.setState({ target });

/** Close the launcher. */
export const closeMeeting = (): void => meetingUi.setState({ target: null });

export const setPreferredDevices = (micId: string, camId: string): void => meetingUi.setState({ devices: { micId, camId } });

export const useMeetingTarget = (): MeetingTarget | null => meetingUi((s) => s.target);

/** A stable string for a target, used as a React key so a different meeting starts a fresh flow. */
export const targetKey = (t: MeetingTarget): string => ("meetingId" in t ? "id:" + t.meetingId : "code" in t ? "code:" + t.code : "url:" + t.joinUrl);
